import React, { useState, useEffect } from 'react';
import { themeColors } from '../../../style/color';
import { Row, Col, Card, CardBody, CardHeader, Badge, Button } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';
import axios from 'axios';
import { mainurl } from '../../../Mainurl'; 
import { FiRefreshCw, FiUser, FiTrendingUp, FiMap, FiBarChart2 } from 'react-icons/fi';

const ReReport = () => {
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [stats, setStats] = useState({
        totalFarmers: 0,
        totalArea: 0,
        totalProduction: 0
    });

    useEffect(() => {
        get_data();
    }, []);

    const get_data = async() => {
        setLoading(true);

        const postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "user_code": sessionStorage.getItem('user_id'),
            "password": sessionStorage.getItem('user_pass')
        }];

        try {
            const response = await axios({
                method: 'post',
                url: mainurl + 'Dashboard/db_exceutive',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl: index + 1,
                    re_name: row.re_name,
                    role_code: row.role_code,
                    farmer_count: row.farmer_count,
                    total_area: row.total_area,
                    production: row.production,
                };
            });

            // Calculate summary statistics
            const totalFarmers = list.reduce((sum, item) => sum + parseInt(item.farmer_count || 0), 0);
            const totalArea = list.reduce((sum, item) => sum + parseFloat(item.total_area || 0), 0);
            const totalProduction = list.reduce((sum, item) => sum + parseFloat(item.production || 0), 0);
            
            setStats({
                totalFarmers,
                totalArea: totalArea.toFixed(2),
                totalProduction: totalProduction.toFixed(2)
            });
            
            setTableData(list);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }

    // Custom styles for the table
    const customTableStyles = {
        ...custTableStyles,
        headCells: {
            style: {
                backgroundColor: themeColors.primary,
                color: 'white',
                fontWeight: 'bold',
                fontSize: '14px',
            },
        },
        rows: {
            style: {
                minHeight: '50px',
                '&:nth-of-type(even)': {
                    backgroundColor: '#f9f9f9',
                },
                '&:hover': {
                    backgroundColor: '#f0f7ff !important',
                },
            },
        },
    };

    // Format numbers with commas
    const formatNumber = (num) => {
        return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
    };

    return (
        <>
            <Row className='ps-2 pe-2 mb-4'>
                <Col md={12}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h3 className="mb-0">RE Performance</h3>
                        <Button 
                            color="primary" 
                            onClick={get_data}
                            disabled={loading}
                            className="d-flex align-items-center"
                        >
                            <FiRefreshCw className={loading ? 'me-2 spin' : 'me-2'} />
                            {loading ? 'Refreshing...' : 'Refresh Data'}
                        </Button>
                    </div>
                </Col>
            </Row>

            {/* Summary Cards */}
            <Row className='ps-2 pe-2 mb-4'>
                <Col md={4} className="mb-3">
                    <Card className="h-100 summary-card">
                        <CardBody className="d-flex align-items-center">
                            <div className="summary-icon me-3 bg-primary-light">
                                <FiUser className="text-primary" />
                            </div>
                            <div>
                                <h6 className="card-title text-muted mb-1">Total Farmers</h6>
                                <h3 className="mb-0">{formatNumber(stats.totalFarmers)}</h3>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mb-3">
                    <Card className="h-100 summary-card">
                        <CardBody className="d-flex align-items-center">
                            <div className="summary-icon me-3 bg-success-light">
                                <FiMap className="text-success" />
                            </div>
                            <div>
                                <h6 className="card-title text-muted mb-1">Total Area (Acre)</h6>
                                <h3 className="mb-0">{formatNumber(stats.totalArea)}</h3>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={4} className="mb-3">
                    <Card className="h-100 summary-card">
                        <CardBody className="d-flex align-items-center">
                            <div className="summary-icon me-3 bg-info-light">
                                <FiBarChart2 className="text-info" />
                            </div>
                            <div>
                                <h6 className="card-title text-muted mb-1">Total Production</h6>
                                <h3 className="mb-0">{formatNumber(stats.totalProduction)}</h3>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row className='ps-2 pe-2 mb-3'>
                <Col md={12}>
                    <Card className="shadow-sm">
                        <CardHeader className="bg-white d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">RE Performance Details</h5>
                            <Badge color="light" className="text-muted">
                                {tableData.length} Records
                            </Badge>
                        </CardHeader>
                        <CardBody>
                            <DataTable
                                title=""
                                customStyles={customTableStyles}
                                columns={[
                                    {
                                        name: '#',
                                        selector: row => row.sl,
                                        sortable: true,
                                        width: '70px',
                                        center: true
                                    },
                                    {
                                        name: 'RE Name',
                                        selector: row => row.re_name,
                                        sortable: true,
                                        cell: row => (
                                            <Badge 
                                                className="text-primary p-2"
                                                color="light"
                                                style={{ 
                                                    borderRadius: '6px',
                                                    fontWeight: '500',
                                                    background: '#e8f4ff'
                                                }}
                                            >
                                                {row.re_name}
                                            </Badge>
                                        )
                                    },
                                    {
                                        name: 'Role',
                                        selector: row => row.role_code,
                                        sortable: true,
                                        cell: row => (
                                            <Badge color="secondary" pill>
                                                {row.role_code}
                                            </Badge>
                                        )
                                    },
                                    {
                                        name: 'Farmer Count',
                                        selector: row => row.farmer_count,
                                        sortable: true,
                                        cell: row => (
                                            <div>
                                                {formatNumber(row.farmer_count)}
                                            </div>
                                        )
                                    },
                                    {
                                        name: 'Total Area',
                                        selector: row => row.total_area,
                                        sortable: true,
                                        cell: row => (
                                            <div>
                                                {formatNumber(row.total_area)}
                                            </div>
                                        )
                                    },
                                    {
                                        name: 'Total Production',
                                        selector: row => row.production,
                                        sortable: true,
                                        cell: row => (
                                            <div>
                                                {formatNumber(row.production)}
                                            </div>
                                        )
                                    },
                                ]}
                                data={tableData}
                                progressPending={loading}
                                progressComponent={<div className="p-5 text-center">Loading data...</div>}
                                highlightOnHover
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                noDataComponent={<div className="p-5 text-center">No data available</div>}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <style>{`
                .summary-card {
                    border: none;
                    border-radius: 12px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
                    transition: transform 0.2s;
                }
                
                .summary-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 15px rgba(0,0,0,0.1);
                }
                
                .summary-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                }
                
                .bg-primary-light {
                    background-color: rgba(13,110,253,0.15);
                }
                
                .bg-success-light {
                    background-color: rgba(25,135,84,0.15);
                }
                
                .bg-info-light {
                    background-color: rgba(13,202,240,0.15);
                }
                
                .spin {
                    animation: spin 1s linear infinite;
                }
                
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </>
    )
}

export default ReReport;